import React from "react";
import { T } from "./tokens";

/** CSS-only gold ornamental rule — extracted from HomeV3Page for reuse. */
export default function GoldRule({ wide = false }) {
  return (
    <div
      className="flex items-center gap-2"
      style={{ width: wide ? "100%" : "80px", maxWidth: wide ? 320 : 80 }}
    >
      <div style={{ flex: 1, height: "1px", background: `linear-gradient(to right, transparent, ${T.GOLD})` }} />
      <span style={{ color: T.GOLD, fontSize: "9px", lineHeight: 1 }}>&#10022;</span>
      <div style={{ flex: 1, height: "1px", background: `linear-gradient(to left, transparent, ${T.GOLD})` }} />
    </div>
  );
}
